import Swiper, {Navigation, Lazy} from "swiper";
Swiper.use([Navigation, Lazy]);

const initProgramsSlider = () => {
  const sliderContainer = document.querySelector("[data-programs-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    lazy: true,
    spaceBetween: 12,
    breakpoints: {         
      997: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },              
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },       
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    },
    navigation: {
      nextEl: "[data-programs-slider-container] .slider-navigation__button--next",
      prevEl: "[data-programs-slider-container] .slider-navigation__button--prev",
    },
  });  
};

export default initProgramsSlider;
